import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  FormGroup,
  FormLabel,
  Alert
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { Link } from "react-router-dom"; 
import * as fb from '../../firebase';
import {addAdminLog} from "../../components/Helper";

class AddMeta extends Component {
  constructor(props){
    super(props);
    this.state = {
      key:"",
      value:"",
      value_ru:"",
      category:"",
      categoryOptions: [
        {id:'txt',name:'Text'},
        {id:'notifications_txt',name:'Notifications'},
        {id:'questionnaire',name:'Questionnaire'},
        {id:'instruction_txt',name:'Instruction'},
        {id:'portal_txt',name:'Portal'},
      ],
      disabled : false,
      error:"",
      errors:{}
    }
  }

  onChangeHandler = (event) => {
    const {name, value} = event.currentTarget;
    if(name === 'key') {
      this.setState({
        key:value
      });
    }else if(name === 'value') {
      this.setState({
        value:value
      });
    }else if(name === 'value_ru') {
      this.setState({
        value_ru:value
      });
    }else if(name === 'category') {
      this.setState({
        category:value
      });
    }
  };

  handleValidation = () => {
    let {key, value, value_ru, category} = this.state;
    let errors = {};
    let formIsValid = true;

    //key
    if(!key){
      formIsValid = false;
      errors["key"] = "Key is required";
    }

    //Value EN
    if(!value){
      formIsValid = false;
      errors["value"] = "Value EN is required";
    }

    //Value RU
    if(!value_ru){
      formIsValid = false;
      errors["value_ru"] = "Value RU is required";
    }

    if(!category){
      formIsValid = false;
      errors["category"] = "Category is required";
    }
    this.setState({errors: errors});
    return formIsValid;
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this._isMounted = true;
    this.setState({disabled: true});
    if(this.handleValidation(this.state.errors)){
      await fb.metaCollection.doc(this.state.category).update({
        [this.state.key]:this.state.value
      }).then(snapShot => {
        // this.props.history.push('/admin/meta')
      }).catch(err=> {
        this.setState({
          error:`Something went wrong-${err}`,
          disabled: false
        });
      });
      
      await fb.metaCollection.doc(`${this.state.category}_ru`).update({
        [this.state.key]:this.state.value_ru
      }).then(snapShot => {
        this.props.history.push('/admin/meta')
      }).catch(err=> {
        this.setState({
          error:`Something went wrong-${err}`,
          disabled: false
        });
      });
      addAdminLog('meta_created',
        `Created the meta ${this.state.key} at the ${this.state.category}`)
    }else{
      this.setState({
        disabled: false
      });
    }
  }
  
  render() {
    console.log('render', this.state)
    return (
      <div className="content">
        <Container fluid>
          <Row>
            <Col md={12}>
              {this.state.error &&
                <Alert bsStyle="danger">
                  <button type="button" aria-hidden="true" className="close">
                    &#x2715;
                  </button>
                  <span>{this.state.error}</span>
                </Alert>
              }
              <Card
                title="Add Meta Text"
                button={
                  <Link to={`/admin/meta`} className="btn btn-success pull-left card-back-button libi-admin-btn"> Back</Link>
                }
                content={
                  <form onSubmit={this.handleSubmit}>
                    <Row>
                      <div className="col-md-12">
                        <FormGroup>
                          <FormLabel>Key</FormLabel>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Key"
                            name="key"
                            value= {this.state.key}
                            onChange = {(event) => this.onChangeHandler(event)}
                          />
                          <span className="help-block">{this.state.errors.key}</span>
                        </FormGroup>
                      </div>
                    </Row>
                    <Row>
                      <div className="col-md-12">
                        <FormGroup>
                          <FormLabel>Value EN</FormLabel>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Value EN"
                            name="value"
                            value= {this.state.value}
                            onChange ={(event)=>this.onChangeHandler(event)}
                          />
                          <span className="help-block">{this.state.errors.value}</span>
                        </FormGroup>
                      </div>
                    </Row>
                    <Row>
                      <div className="col-md-12">
                        <FormGroup>
                          <FormLabel>Value RU</FormLabel>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Value RU"
                            name="value_ru"
                            value= {this.state.value_ru}
                            onChange ={(event)=>this.onChangeHandler(event)}
                          />
                          <span className="help-block">{this.state.errors.value_ru}</span>
                        </FormGroup>
                      </div>
                    </Row>
                    <Row>
                      <div className="col-md-12">
                        <FormGroup>
                          <FormLabel>Category</FormLabel>
                          <select
                            className="form-control"
                            name="category"
                            value={this.state.category}
                            onChange={(event) => this.onChangeHandler(event)}
                          >
                            <option value="">Select category</option>
                            {
                              this.state.categoryOptions.map((cat, index) => {
                                return <option key={index} value={cat.id}>{cat.name}</option>
                              })
                            }
                          </select>
                          <span className="help-block">{this.state.errors.category}</span>
                        </FormGroup>
                      </div>
                    </Row>
                    <Button
                      className="btn-fill pull-right libi-admin-btn"
                      bsStyle="info" 
                      pullRight fill 
                      type="submit"
                      disabled={this.state.disabled}
                    >
                      {this.state.disabled ? 'Loading...' : 'Add'}
                    </Button>
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default AddMeta;
